/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { Container } from 'reactstrap';

import * as actions from '../../store/actions/index';

import Tabs from '../../components/Tabs/Tabs';
import Header from '../../components/Header/Header';
import Modal, { modalTypes } from '../../components/Modal/Modal';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import Loading from '../../components/Loading/Loading';

import ContractorDetailsForm from '../../components/ContractorDetailsForm/ContractorDetailsForm';
import ContractorFileForm from '../../components/ContractorFileForm/ContractorFileForm';

import messages from './ContractorDetailsPage.intl';

import { AuthContext } from '../../context/AuthContext';

class ContractorDetailsPage extends Component {
    static contextType = AuthContext;

    state = {
        activeTab: 0,
        showModal: false,
        cities: [],
        selectedState: null,
        selectedCity: null,
    };

    componentDidMount() {
        this.props.onInitContractorDetails(this.props.match.params.id);
        this.props.onInitStates();
        this.props.onInitCities();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.contractor !== this.props.contractor) {
            if (this.props.contractor)
                this.props.onInitCities(
                    this.props.contractor &&
                        this.props.contractor.address.state,
                );
        }
    }

    handleTabClick = (e, index) => {
        if (this.state.activeTab !== index) {
            this.setState({
                activeTab: index,
            });
        }
    };

    handleSubmit = (event, values) => {
        if (this.props.loadingDetails) return;

        values.Billing.Emails = values.Billing.Emails.replace(/\s/g, '').split(
            ';',
        );

        const contractor = this.props.contractor || {};
        const payload = {
            ...values,
        };

        if (this.props.match.params.id === 'new') {
            this.props.onCreateContractor(payload);
        } else {
            this.props.onUpdateContractor(contractor.contractorId, payload);
        }
    };

    handleNewLogoFileSaveButtonClick = (file) => {
        const { contractorId } = this.props.contractor;
        this.props.onUploadContractorNormalLogo(contractorId, file);
    };

    handleNewSmallLogoSaveButtonClick = (file) => {
        const { contractorId } = this.props.contractor;
        this.props.onUploadContractorSmallLogo(contractorId, file);
    };

    handleNewCustomerAppLogoSaveButtonClick = (file) => {
        const { contractorId } = this.props.contractor;
        this.props.onUploadCustomerAppLogo(contractorId, file);
    };

    handleNewAttachmentSaveButtonClick = (file) => {
        const { contractorId } = this.props.contractor;
        this.props.onUploadContractorAttachment(contractorId, file);
    };

    handleToggleModal = () => {
        this.setState({
            showModal: !this.state.showModal,
        });
    };

    handleToggleDelete = async () => {
        this.setState({
            showModal: !this.state.showModal,
        });

        await this.props.onDeleteContractor(this.props.contractor.contractorId);
    };

    handleStateChange = (selectedState) => {
        const state = this.props.states.find(
            (s) => s.uf === selectedState.value,
        );
        this.props.onInitCities(selectedState.value);

        this.setState({
            selectedState: {
                selectedLabelOption: state.name,
                selectedValueOption: state.uf,
            },
        });

        this.setState({
            selectedCity: {
                selectedLabelOption: '',
                selectedValueOption: '',
            },
        });
    };

    handleCityChange = (selectedCity) => {
        this.setState({
            selectedCity: {
                selectedLabelOption: selectedCity.label,
                selectedValueOption: selectedCity.value,
            },
        });
    };

    render() {
        const {
            intl,
            loadingDetails,
            loadingNormalLogo,
            loadingSmallLogo,
            loadingCustomerAppLogo,
            loadingAttachment,
            states,
            cities,
        } = this.props;

        const contractor = this.props.contractor || {};
        const isNew = this.props.match.params.id === 'new';

        const hasClainToViewFiles =
            this.context.hasClaim('contractor-view') ||
            this.context.hasClaim('contractor-small-logo-view') ||
            this.context.hasClaim('contractor-attachment-view');

        const canViewContractorFiles = hasClainToViewFiles ? !isNew : false;

        const canCreateContractor =
            this.context.hasClaim('contractor-create') && isNew;

        const canDeleteContractor =
            this.context.hasClaim('contractor-delete') && !isNew;

        const canUpdateContractor =
            this.context.hasClaim('contractor-update') && !isNew;

        const readOnly = !(canCreateContractor || canUpdateContractor);

        return (
            <Container fluid>
                <Breadcrumb
                    routes={[
                        {
                            path: '/home',
                            name: intl.formatMessage(messages.home),
                            active: false,
                        },
                        {
                            path: '/contractors',
                            name: intl.formatMessage(messages.title),
                            active: false,
                        },
                        {
                            path: '/contractors/:id',
                            name: intl.formatMessage(messages.titleContractor, {
                                entity:
                                    this.props.contractor &&
                                    this.props.contractor.displayName,
                            }),
                            active: true,
                        },
                    ]}
                />
                <header>
                    <section className='title'>
                        <Header
                            title={intl.formatMessage(
                                messages.titleContractor,
                                {
                                    entity: '',
                                },
                            )}
                        />
                    </section>
                </header>
                <section className='content-middle bg-content'>
                    <Loading loading={loadingDetails} />
                    <Tabs
                        handleTabClick={this.handleTabClick}
                        activeTab={this.state.activeTab}
                        tabs={[
                            {
                                name: intl.formatMessage(
                                    messages.registrationInfo,
                                ),
                                component: (
                                    <ContractorDetailsForm
                                        key='contractorsTab'
                                        contractor={contractor}
                                        handleSubmit={this.handleSubmit}
                                        handleToggleModal={
                                            this.handleToggleModal
                                        }
                                        states={states}
                                        cities={cities}
                                        handleStateChange={
                                            this.handleStateChange
                                        }
                                        handleCityChange={this.handleCityChange}
                                        readOnly={readOnly}
                                        canDeleteContractor={
                                            canDeleteContractor
                                        }
                                        selectedCity={this.state.selectedCity}
                                        selectedState={this.state.selectedState}
                                    />
                                ),
                            },
                            {
                                name: 'Importar Arquivo',
                                disabled: !canViewContractorFiles,
                                component: (
                                    <ContractorFileForm
                                        key='filesTab'
                                        contractor={contractor}
                                        handleNewLogoFileSaveButtonClick={
                                            this
                                                .handleNewLogoFileSaveButtonClick
                                        }
                                        handleNewSmallLogoSaveButtonClick={
                                            this
                                                .handleNewSmallLogoSaveButtonClick
                                        }
                                        handleNewAttachmentSaveButtonClick={
                                            this
                                                .handleNewAttachmentSaveButtonClick
                                        }
                                        handleNewCustomerAppLogoSaveButtonClick={
                                            this
                                                .handleNewCustomerAppLogoSaveButtonClick
                                        }
                                        loading={loadingDetails}
                                        loadingNormalLogo={loadingNormalLogo}
                                        loadingSmallLogo={loadingSmallLogo}
                                        loadingCustomerAppLogo={
                                            loadingCustomerAppLogo
                                        }
                                        loadingAttachment={loadingAttachment}
                                        isSystem={
                                            this.context.contractor.isSystem
                                        }
                                    />
                                ),
                            },
                        ]}
                    />
                </section>
                <Modal
                    title={intl.formatMessage(messages.deleteContractor)}
                    isOpen={this.state.showModal}
                    handleToggle={this.handleToggleModal}
                    type={modalTypes.ERROR}
                    hasFooter
                    firstButtonText={intl.formatMessage(messages.yesText)}
                    secondButtonText={intl.formatMessage(messages.noText)}
                    toggleFirstButton={this.handleToggleDelete}
                    toggleSecondButton={this.handleToggleModal}
                >
                    {intl.formatMessage(messages.confirmDeleteText)}
                </Modal>
            </Container>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        contractor: state.contractorReducer.contractor,
        loadingDetails: state.contractorReducer.loadingDetails,
        states: state.stateReducer.states,
        cities: state.stateReducer.cities,
        file: state.fileReducer.file,
        normalLogoFileId: state.contractorReducer.normalLogoFileId,
        smallLogoFileId: state.contractorReducer.smallLogoFileId,
        attachmentFileId: state.contractorReducer.attachmentFileId,
        loadingNormalLogo: state.contractorReducer.loadingNormalLogo,
        loadingSmallLogo: state.contractorReducer.loadingSmallLogo,
        loadingAttachment: state.contractorReducer.loadingAttachment,
        loadingCustomerAppLogo: state.contractorReducer.loadingCustomerAppLogo,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onInitContractorDetails: (contractorId) =>
            dispatch(actions.initContractorDetails(contractorId)),
        onCreateContractor: (values) =>
            dispatch(actions.createContractor(values)),
        onUpdateContractor: (contractorId, values) =>
            dispatch(actions.updateContractor(contractorId, values)),
        onDeleteContractor: (values) =>
            dispatch(actions.deleteContractor(values)),
        onInitStates: () => dispatch(actions.initStates()),
        onInitCities: (uf) => dispatch(actions.initCities(uf)),
        onUploadContractorNormalLogo: (contractorId, file) =>
            dispatch(actions.uploadContractorNormalLogo(contractorId, file)),
        onUploadContractorSmallLogo: (contractorId, file) =>
            dispatch(actions.uploadContractorSmallLogo(contractorId, file)),
        onUploadCustomerAppLogo: (contractorId, file) =>
            dispatch(
                actions.uploadContractorCustomerAppLogo(contractorId, file),
            ),
        onUploadContractorAttachment: (contractorId, file) =>
            dispatch(actions.uploadContractorAttachment(contractorId, file)),
    };
};

export default injectIntl(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(ContractorDetailsPage),
);
